import React from 'react'
import { mergeClasses } from '@/helpers/styling'
import { SimpleTooltip, SimpleTooltipProvider } from '@/components/ui-primitives/simple-tooltip'
import { SvgIcon, SvgIconType } from '@/components/svg-icon'
import { ACCENT } from '@/components/editor/accent'

export function SidebarRailChrome(props: {
  children: React.ReactNode
}) {
  return (
    <div className="h-full flex flex-col items-center gap-1 px-1.5 py-2 text-foreground/65 bg-white0 border-l border-border">
      <SimpleTooltipProvider delayDuration={700}>
        {props.children}
      </SimpleTooltipProvider>
    </div>
  )
}

function SidebarRailChromeSeparator() {
  return <div aria-hidden className="w-5 h-px my-1 bg-border" />
}

function SidebarRailChromeIcon(props: {
  icon: SvgIconType
  title?: string
  active?: boolean
  semiActive?: boolean
  onClick: () => void
  children?: React.ReactNode
}) {
  return (
    <SimpleTooltip tooltip={props.title}
                   withProvider={false}
                   tooltipProps={{ side: "left" }}>
      <button type="button"
              aria-label={props.title}
              aria-pressed={props.active}
              onClick={props.onClick}
              className={mergeClasses(`relative flex items-center justify-center size-8 shrink-0
                rounded-md border-[1px] border-transparent
                hover:bg-muted hover:text-foreground transition-colors`, ACCENT.focusRing, {
                [`border-dashed ${ACCENT.semiActiveTile}`]: props.semiActive,
                [`${ACCENT.iconTile} ${ACCENT.railIndicator} hover:bg-[#51479e]/15 hover:text-[#51479e]`]: props.active
              })}>
        <SvgIcon icon={props.icon} size={17} />
        {props.children && (
          <span className="pointer-events-none absolute top-1 right-1 flex rounded-full ring-2 ring-white [&>*]:!static [&>*]:!m-0">
            {props.children}
          </span>
        )}
      </button>
    </SimpleTooltip>
  )
}

SidebarRailChrome.Icon = SidebarRailChromeIcon
SidebarRailChrome.Separator = SidebarRailChromeSeparator
